import * as React from "react";
const SellComercialSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={700}
    fill="none"
    className="svg-overlay large-device-svg"
    viewBox="0 0 1112 676"
    {...props}
  >
    <path
      fill="#F4F7FA"
      d="M1112 0H-101l.5 676H782L1112 0Z"
      className="background-video-br-page"
      style={{
        transform: "scaleX(.9)",
      }}
    />
  </svg>
);
export default SellComercialSvg;
